var render = function render(){var _vm=this,_c=_vm._self._c;return _c('figure',{ref:"youtubePlaceHolder",staticClass:"image is-16by9 wrapper-embed",domProps:{"innerHTML":_vm._s(_vm.buildIframe())}})
}
var staticRenderFns = []

export { render, staticRenderFns }